

import { NButton } from "naive-ui";
import { mapStores } from "pinia";
import { defineComponent } from "vue";
import { useAuthStore } from "~/store/auth.store";

export default defineComponent({

    components: {
        NButton,
    },

    data() {
        return {
            showPassword : false,
            email : '',
            error: false,
            success: false,
            isLoading: false,
        };
    },

    computed: {
        ...mapStores(useAuthStore),
        logo() {
            return require('../../img/elichens-logo-600px.png').default
        },
        userImg() {
            return require('../../img/profile-pic.png').default
        }
    },

    methods: {
        onSubmit(e: Event) {
            e.preventDefault();
            this.error = false;
            this.isLoading = true;
            this.authStore.forgotPassword(this.email)
                .then(() => {
                    this.success = true;
                })
                .catch((error: Error) => {
                    console.error(error);
                    this.error = true;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        togglePasswordVisibility(): void {
            this.showPassword = !this.showPassword;
        }
    }

});

